<template>
  <div class="home--included">
    <div class="home--included__wrapper">
      <div
        class="home--included__title h1 text-center txt-upper mB8 section__title"
        v-html="$t('includes.title')"
      ></div>

      <p class="text-center body-small mB24" v-html="$t('includes.desc')"></p>

      <div>
        <IncludeCol
          v-in-viewport="'animate__fadeUp'"
          v-for="(item, index) in includeDetails"
          :data="item"
          :key="index"
          :position="(index + 1) % 2 === 0 ? 'even' : 'odd'"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { IncludeCol } from "~/components/";

export default {
  name: "HomeIncluded",
  components: {
    IncludeCol,
  },
  computed: {
    includeDetails() {
      return this.$t("includes.details");
    },
  },
};
</script>

<style lang="scss">
@import "~/scss/include/_commonInclude.scss";
.content .app {
  .home--included {
    width: 100%;
    overflow-x: hidden;
    background-color: color(whiteAbs);

    &__wrapper {
      max-width: rem(1440);
      width: 100%;
      margin-left: auto;
      margin-right: auto;
      padding-top: rem(80);
    }

    &__title {
      letter-spacing: 0.1em;
    }
  }
}
</style>
